<template>
  <!-- 百草健康 -->
  <!-- 登录账号之后 点击头像有个 我的地址页面 -->
  <div>
    <div class="sub-container">
      <el-page-header class="page-header" @back="goBack" content="我的地址"></el-page-header>
      <div class="contact-header">
        <el-button class="btn-add-contact" type="primary" icon="el-icon-plus"
          @click="showAddDialog = true">添加地址</el-button>
        <div class="search-right">
          <el-input class="input-circle" v-model="searchText" placeholder="收件人姓名或手机号码" clearable></el-input>
          <el-button class="button-search" round @click="getAddressList">搜 索</el-button>
        </div>
      </div>
      <el-table class="address-table" :data="addressList" style="width: 100%" :border="false">
        <el-table-column prop="receiverName" label="姓名" min-width="120">
        </el-table-column>
        <el-table-column prop="addressInfoText" label="省市区" min-width="220">
        </el-table-column>
        <el-table-column prop="street" label="详细地址" min-width="200">
        </el-table-column>
        <el-table-column prop="phoneNo" label="电话" min-width="140">
        </el-table-column>
        <el-table-column prop="zipCode" label="邮编" min-width="90">
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="300">
          <template slot-scope="scope">
            <el-button class="address-op-btn" type="text" size="medium" v-if="isSelect"
              @click="selectAddress(scope.row)"><i class="el-icon-circle-check"></i> 选择</el-button>
            <el-button class="address-op-btn address-op-edit" type="text" size="medium"
              @click="editAddress(scope.row)"><i class="el-icon-edit"></i> 编辑</el-button>
            <el-button class="address-op-btn address-op-delete" type="text" size="medium"
              @click="deleteAddress(scope.row)"><i class="el-icon-delete"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="totalPage > 10" class="pagination" background layout="prev, pager, next"
        :current-page="currentPageNo" @current-change="pageChange" :total="totalPage">
      </el-pagination>
      <div class="empty-container" v-if="addressList.length == 0">
        <span>{{ emptyText }}</span>
      </div>
    </div>
    <el-dialog :title="isEdit ? '编辑地址' : '添加地址'" :visible.sync="showAddDialog" center destroy-on-close width="750px"
      custom-class="address-dialog">
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="160px" label-position="right" class="basic-info" :model="deliveryFormData">
          <el-form-item label="*姓名：" class="form-item">
            <el-input v-model="deliveryFormData.receiverName" ref="nameId" type="text" placeholder="请输入收件人姓名"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="*联系电话：" class="form-item">
            <el-input v-model="deliveryFormData.phoneNo" ref="phoneId" type="number" placeholder="请输入联系人手机号码"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="*省市区：" class="form-item">
            <el-cascader style="width: 100%;" placeholder="请选择省市区" @change="addressChange"
              v-model="deliveryFormData.addressInfo" :props="props"></el-cascader>
            <span v-show="addressTemp && addressTemp.length > 0"
              style="text-align: start;width: 300px; position: absolute;color: #606266;background-color: white;left: 10px;line-height: 14px;">{{
              addressTemp }}</span>
          </el-form-item>
          <el-form-item label="*详细地址：" class="form-item">
            <el-input v-model="deliveryFormData.street" type="textarea" ref="customAddressId"
              placeholder="请输入详细地址(街道门牌信息)" clearable></el-input>
          </el-form-item>
          <el-form-item label="邮政编码：" class="form-item">
            <el-input v-model="deliveryFormData.zipCode" type="number" placeholder="请输入邮政编码" clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-actions">
          <el-button class="dialog-btn-cancel" size="medium" @click="dismiss">取 消</el-button>
          <el-button class="dialog-btn-save" type="primary" size="medium" @click="saveAddress">保 存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import AreaHeader from '@/components/widgets/area-header.vue'
import area from '../../js/area'
import { EventBus } from "../../js/eventbus.js"
export default {
  components: {
    AreaHeader,
  },
  data() {
    return {
      addressList: [],
      deliveryFormData: {
        city: "",
        county: "",
        phoneNo: "",
        province: "",
        receiverName: "",
        street: "",
        zipCode: '',
        addressInfo: [],
        addressInfoText: [],
      },
      showAddDialog: false,
      searchText: '',
      addressTemp: '',
      currentPageNo: 1,
      pageSize: 12,
      totalPage: 1,
      emptyText: '您还没有地址',
      isEdit: false,
      isSelect: false,
      props: {
        lazy: true,
        value: 'label',
        lazyLoad(node, resolve) {
          console.log(node)
          var nodes = []
          if (node.level == 0) {
            for (var key in area.province_list) {
              var item = {
                label: area.province_list[key],
                value: key,
                leaf: false
              }
              nodes.push(item)
            }
          }
          if (node.level == 1) {
            var provinceCode = node.data.value.substring(0, 2)
            for (var key in area.city_list) {
              if (provinceCode == key.substring(0, 2)) {
                var item = {
                  label: area.city_list[key],
                  value: key,
                  leaf: false
                }
                nodes.push(item)
              }
            }
          }
          if (node.level == 2) {
            var cityCode = node.data.value.substring(0, 4)
            for (var key in area.county_list) {
              if (cityCode == key.substring(0, 4)) {
                var item = {
                  label: area.county_list[key],
                  value: key,
                  leaf: true
                }
                nodes.push(item)
              }
            }
          }
          resolve(nodes)
        }
      },
    }
  },
  created() {
    var mode = this.$route.query.mode
    this.isSelect = mode == 1
    this.getAddressList()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getAddressList() {
      this.wjtHttp.get(this, '/api/delivery/address/list', {
        pageNum: this.currentPageNo,
        pageSize: this.pageSize,
        keyWord: this.searchText
      }, true, (res) => {
        var data = res.data
        if (data.code == 200) {
          if (!this.utils.isEmptyStr(data.rows)) {
            this.totalPage = Math.ceil(data.total / 12) * 10
          } else if (this.currentPageNo == 1) {
            this.totalPage = 1
          }
          for (var i = 0; i < data.rows.length; i++) {
            var item = data.rows[i]
            item.addressInfo = [item.province, item.city, item.county]
            item.addressInfoText = item.province + '/' + item.city + '/' + item.county
          }
          this.addressList = data.rows
        } else {
          this.$message({
            message: (data.msg && data.msg.length > 0) ? data.msg : '获取地址列表异常',
            type: 'error'
          })
        }
      }, (err) => {
        console.log(err)
      })
    },
    dismiss() {
      this.showAddDialog = false
      this.cancelEdit()
    },
    addressChange(e) {
      console.log(e)
      if (e.length >= 3) {
        this.deliveryFormData.province = e[0]
        this.deliveryFormData.city = e[1]
        this.deliveryFormData.county = e[2]
        this.addressTemp = ''
      }
    },
    editAddress(item) {
      console.log(item)
      this.deliveryFormData = {
        receiverName: item.receiverName,
        phoneNo: item.phoneNo,
        province: item.province,
        city: item.city,
        county: item.county,
        street: item.street,
        zipCode: item.zipCode,
        addressInfo: [item.province, item.city, item.county],
        addressInfoText: item.province + '/' + item.city + '/' + item.county,
        deliveryAddressId: item.deliveryAddressId
      }
      this.isEdit = true
      this.showAddDialog = true
      this.addressTemp = this.deliveryFormData.addressInfoText
    },
    deleteAddress(item) {
      this.$confirm('确定删除该地址信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.wjtHttp.delete(this, '/api/delivery/address/' + item.deliveryAddressId, {}, true, (res) => {
          var data = res.data
          if (data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getAddressList()
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '删除地址列表异常',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
        })
      }).catch(() => {

      });

    },
    saveAddress() {
      if (this.deliveryFormData.receiverName.length == 0) {
        this.$nextTick(() => {
          this.$refs.nameId.focus();
        })
        this.$message("请输入收件人姓名")
        return
      }
      if (this.deliveryFormData.phoneNo.length != 11) {
        this.$nextTick(() => {
          this.$refs.phoneId.focus();
        })
        this.$message("请输入正确的11位手机号")
        return
      }
      if (this.deliveryFormData.addressInfo.length == 0) {
        this.$message("请选择省市区")
        return
      }
      if (this.deliveryFormData.street.length == 0) {
        this.$nextTick(() => {
          this.$refs.customAddress.focus();
        })
        this.$message("请输入详细地址")
        return
      }
      this.wjtHttp.post(this, this.isEdit ? '/api/delivery/address/edit' : '/api/delivery/address/add', this.deliveryFormData, true, (res) => {
        var data = res.data
        if (data.code == 200) {
          this.clearAddress()
          this.getAddressList()
          this.showAddDialog = false
        } else {
          this.$message({
            message: (data.msg && data.msg.length > 0) ? data.msg : (this.isEdit ? "编辑地址异常" : '获取地址列表异常'),
            type: 'error'
          })
        }
      }, (err) => {
        console.log(err)
      })
    },
    cancelEdit() {
      this.isEdit = false
      this.clearAddress()
      this.addressTemp = ""
    },
    clearAddress() {
      this.deliveryFormData = {
        city: "",
        county: "",
        phoneNo: "",
        province: "",
        receiverName: "",
        street: "",
        zipCode: '',
        addressInfo: [],
        addressInfoText: '',
        deliveryAddressId: ""
      }
      this.addressTemp = ""
    },
    selectAddress(item) {
      console.log("item:", item)
      sessionStorage.setItem('selectAddress', JSON.stringify(item))
      this.$router.go(-1)
    },
    pageChange(pageNo) {
      this.currentPageNo = pageNo
      this.getAddressList()
    },
  },
  watch: {
    searchText: function (val) {
      if (this.utils.isEmptyStr(val)) {
        this.currentPageNo = 1
        this.getAddressList()
      }
    },
    showAddDialog: function (val) {
      if (!val) {
        this.cancelEdit()
      }
    }
  }
}
</script>

<style scoped>
.btn-add-contact {
  font-size: 16px;
  border-radius: 10px !important;
}

.sub-container {
  width: 1160px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 70vh;
  padding-bottom: 100px;
}

.page-header {
  margin-top: 20px;
  margin-bottom: 20px;
  color: #333333;
  font-size: 20px;
}

.page-header>>>div {
  color: #333333;
  font-size: 20px;
}

.contact-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f9fafb;
  width: 100%;
  border-radius: 14px;
  margin-bottom: 20px;
  gap: 16px;
}

.search-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.input-circle {
  width: 320px;
  height: 40px;
}

.input-circle>>>input {
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-color: #e2e8f0;
  height: 40px;
}

.input-circle>>>input:focus {
  border-color: #20863F;
}

.button-search {
  height: 40px;
  width: 100px;
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
  font-weight: 600;
}

.button-search:hover {
  background-color: #257648;
  border-color: #257648;
  color: #fff;
}

/* 地址表格绿色主题 */
.address-table {
  width: 100% !important;
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
}

.address-table>>>.el-table {
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
}

.address-table>>>.el-table__header-wrapper,
.address-table>>>.el-table__body-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

.address-table>>>.el-table__header thead tr:first-child th:first-child {
  border-top-left-radius: 14px;
}

.address-table>>>.el-table__header thead tr:first-child th:last-child {
  border-top-right-radius: 14px;
}

.address-table>>>.el-table--border {
  border-color: #d3e6d8;
}

.address-table>>>.el-table--border th.el-table__cell,
.address-table>>>.el-table--border td.el-table__cell {
  border-color: #d3e6d8;
}

.address-table>>>th.el-table__cell {
  background: #20863F !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.address-table>>>td.el-table__cell {
  color: #385846;
}

.address-table>>>.el-table__row:hover>td.el-table__cell {
  background-color: #f3fbf6 !important;
}

/* 操作按钮 */
.address-op-btn {
  color: #20863F;
  font-weight: 500;
  padding: 6px 8px;
}

.address-op-btn:hover {
  color: #257648;
}

.address-op-btn i {
  margin-right: 2px;
}

.address-op-delete {
  color: #d35342;
}

.address-op-delete:hover {
  color: #b93c2e;
}

/* 分页 */
.pagination {
  margin-top: 20px;
  margin-bottom: 10px;
  align-self: center;
}

/* 空状态 */
.empty-container {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-container>span {
  font-size: 20px;
  color: #aeaeae;
}

/* 对话框 */
.address-dialog {
  border-radius: 14px;
}

.address-dialog>>>.el-dialog__header {
  background: #f9fafb;
  border-radius: 14px 14px 0 0;
  padding: 20px 24px;
  border-bottom: 1px solid #eef1f0;
}

.address-dialog>>>.el-dialog__title {
  font-size: 18px;
  font-weight: 700;
  color: #072f1e;
}

.address-dialog>>>.el-dialog__body {
  padding: 24px 32px;
}

.basic-info {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.form-item {
  width: 100%;
}

.basic-info>>>.el-input__inner,
.basic-info>>>.el-textarea__inner {
  border-radius: 10px;
  border-color: #e2e8f0;
}

.basic-info>>>.el-input__inner:focus,
.basic-info>>>.el-textarea__inner:focus {
  border-color: #20863F;
}

.dialog-actions {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 32px;
  margin-top: 10px;
  margin-bottom: 6px;
}

.dialog-btn-save {
  width: 180px;
  border-radius: 12px;
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
  font-weight: 600;
}

.dialog-btn-save:hover {
  background-color: #257648;
  border-color: #257648;
}

.dialog-btn-cancel {
  width: 180px;
  border-radius: 12px;
  border-color: #20863F;
  color: #20863F;
  font-weight: 600;
}

.dialog-btn-cancel:hover {
  background-color: #f3fbf6;
  border-color: #20863F;
  color: #20863F;
}
</style>
